import React from 'react';
import { Link } from 'react-router-dom';
import { ButtonProps } from '../types';
import '../styles/Button.css';

const Button: React.FC<ButtonProps> = ({ 
  href, 
  text, 
  isPrimary = false,
  className = '',
  isRouterLink = false,
  download
}) => {
  const buttonClass = `btn ${isPrimary ? 'primary-btn' : 'secondary-btn'} ${className}`;
  
  return isRouterLink ? (
    <Link to={href} className={buttonClass}>
      {text}
    </Link>
  ) : (
    <a href={href} className={buttonClass} download={download}>
      {text}
    </a>
  );
};

export default Button; 